const updateLoginLoading = (state, { payload: { loading } }) => {
	state.loading = loading;
};

export default updateLoginLoading;
